import { errorlog } from "./ErrorLogService";

function hidepopups() {
    document.getElementById("pastdue_block_model").style.display ="none";
    document.getElementById("pastdue_pay_model").style.display ="none";
    document.getElementsByClassName("anim-new-modal-overlay")[0].style.display = "none";
    window.closePastDuePopups();
}
export const payPaymentDue = (propsToDispatch,teamId,type,socket,appType,upgradeType)=>{
    try{
        propsToDispatch.setWorkspaceTextFocus(true);
      const paymentDue =  window.pastduepopup(teamId,type,appType,upgradeType)
        .then((result)=> {
            result = JSON.parse(result);
            propsToDispatch.setWorkspaceTextFocus(false);
            if(result.error){
                propsToDispatch.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : result.errormsg, formatId: 'msg'});
                hidepopups();
            }
            else if(!result.ispastdue){
                propsToDispatch.setPaymentPastDue({status:result.ispastdue,message:'',action:'banner'},socket)
                propsToDispatch.manageToast({action : "add", type : "success", "message" : result.errormsg});
                hidepopups();
                return true;
            }
        })
        .catch((err)=> {
            propsToDispatch.setWorkspaceTextFocus(false);
            propsToDispatch.manageToast({action : "add", type : "error", "message" : "common.toast.msg", subMessage : "common.toast.submsg", formatId: 'both'});
            hidepopups();
        })   
         return paymentDue;     
    }
    catch(err){
        errorlog('Error in PaymentDuePay',err,'PaymentDueHelper-PaymentDue')
    }
}


// WEBPACK FOOTER //
// ./src/helpers/PaymentDueHelper.js